import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

/**
 * Reusable form section with step number and colored left border
 * Used in: PayrollTab, WidgetCustomization, CheckInTab, multi-step forms
 * 
 * Colors: 'blue' | 'purple' | 'green' | 'orange' | 'red' | 'gray'
 */
const FormSection = ({ 
  stepNumber, 
  title, 
  description,
  children,
  color = 'blue',
  expanded = true,
  onToggle,
  collapsible = false
}) => {
  // Map color names to Tailwind classes
  const colorMap = {
    blue: {
      border: 'border-l-blue-600',
      bg: 'bg-blue-100',
      text: 'text-blue-600'
    },
    purple: {
      border: 'border-l-purple-600',
      bg: 'bg-purple-100',
      text: 'text-purple-600'
    },
    green: {
      border: 'border-l-green-600',
      bg: 'bg-green-100',
      text: 'text-green-600'
    },
    orange: {
      border: 'border-l-orange-500',
      bg: 'bg-orange-100',
      text: 'text-orange-600'
    },
    yellow: {
      border: 'border-l-yellow-500',
      bg: 'bg-yellow-100',
      text: 'text-yellow-600'
    },
    red: {
      border: 'border-l-red-600',
      bg: 'bg-red-100',
      text: 'text-red-600'
    },
    gray: {
      border: 'border-l-gray-500',
      bg: 'bg-gray-100',
      text: 'text-gray-600'
    }
  };

  const colors = colorMap[color] || colorMap.blue;
  
  return (
    <Card className={`border-l-4 ${colors.border} shadow-[0_8px_24px_rgba(0,0,0,0.04)] border-0 border-l-4`}>
      <CardHeader 
        className={collapsible ? 'cursor-pointer' : ''}
        onClick={collapsible ? onToggle : undefined}
      >
        <div className="flex items-start gap-4">
          {stepNumber && (
            <div 
              className={`flex items-center justify-center w-10 h-10 rounded-full font-bold text-lg flex-shrink-0 ${colors.bg} ${colors.text}`}
            >
              {stepNumber}
            </div>
          )}
          <div className="flex-1">
            <CardTitle className="text-xl font-semibold">{title}</CardTitle>
            {description && (
              <p className="text-sm sm:text-base text-gray-600 mt-1">{description}</p>
            )}
          </div>
          {collapsible && (
            <div className="text-gray-400">
              {expanded ? '▼' : '▶'}
            </div>
          )}
        </div>
      </CardHeader>
      {(!collapsible || expanded) && children && (
        <CardContent className="space-y-4">
          {children}
        </CardContent>
      )}
    </Card>
  );
};

export default FormSection;
